const Orientation = {
    lockToPortrait: () => {},
    unlockAllOrientations: () => {},
};

export default Orientation;
